import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

function pegarToken() {
  try {
    return localStorage.getItem("token") || localStorage.getItem("giraia_curso_token") || "";
  } catch (e) {
    return "";
  }
}

async function chamar(caminho, opcoes) {
  const resp = await fetch(API + caminho, Object.assign({}, opcoes, {
    headers: { "Content-Type": "application/json", Authorization: "Bearer " + pegarToken() },
  }));
  let dados = null;
  try { dados = await resp.json(); } catch (e) {}
  if (!resp.ok) {
    const det = (dados && dados.detail) || "";
    if (resp.status === 401 || det === "Not authenticated") throw new Error("Voc\u00ea precisa entrar na sua conta para continuar.");
    if (det === "Forbidden") throw new Error("Esta conta n\u00e3o tem permiss\u00e3o para ver esta p\u00e1gina.");
    throw new Error(det || "Erro " + resp.status);
  }
  return dados;
}

export default function AdminPagamentosCursoPage() {
  const [compras, setCompras] = useState([]);
  const [erro, setErro] = useState("");
  const [msg, setMsg] = useState("");
  const [carregando, setCarregando] = useState(true);

  async function carregar() {
    try {
      const d = await chamar("/admin/cursos/compras-pendentes");
      setCompras(Array.isArray(d) ? d : (d.compras_pendentes || d.compras || d.pendentes || []));
      setErro("");
    } catch (e) {
      setErro(e.message);
    }
    setCarregando(false);
  }

  useEffect(() => {
    carregar();
    // eslint-disable-next-line
  }, []);

  async function confirmar(c) {
    if (!window.confirm("Confirmar o pagamento de " + (c.nome || c.nome_completo || c.email || "este aluno") + "?")) return;
    try {
      await chamar("/admin/cursos/confirmar-pagamento", { method: "POST", body: JSON.stringify({ compra_id: c.id }) });
      setMsg("Pagamento confirmado. M\u00f3dulo liberado para o aluno.");
      carregar();
    } catch (e) {
      setErro(e.message);
    }
  }

  return (
    <div className="min-h-screen bg-[#141118] text-[#F2F0EA] p-4 sm:p-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-[#F2F0EA] text-2xl font-bold mb-1">{"Pagamentos do curso"}</h1>
        <p className="text-[#B8B3A8] mb-6">{"Confira o PIX no banco antes de confirmar."}</p>
        {msg && <p className="mb-4 p-3 rounded-lg bg-green-100 text-green-900">{msg}</p>}
        {erro && (
          <div className="mb-4 p-3 rounded-lg bg-red-100 text-red-900">
            {erro}
            <div className="mt-2"><Link to="/login" className="underline">{"Entrar como administradora"}</Link></div>
          </div>
        )}
        {carregando && <p className="text-[#9A948A]">Carregando...</p>}
        {!carregando && !erro && compras.length === 0 && (
          <p className="p-4 rounded-lg bg-[#1E1A24] shadow text-[#B8B3A8]">{"Nenhuma compra pendente."}</p>
        )}
        {compras.map((c) => (
          <div key={c.id} className="bg-[#1E1A24] rounded-xl shadow p-5 mb-3 flex items-center justify-between gap-3">
            <div>
              <p className="font-semibold">{c.nome || c.nome_completo || c.email}</p>
              <p className="text-sm text-[#B8B3A8]">{c.email}</p>
              <p className="text-sm text-[#B8B3A8]">
                {"M\u00f3dulo " + (c.modulo_numero || "-") + " | R$ " + Number(c.valor || 0).toFixed(2).replace(".", ",")}
              </p>
            </div>
            <button onClick={() => confirmar(c)} className="bg-gold-500 text-[#141118] px-4 py-2 rounded-lg text-sm font-semibold">{"Confirmar pagamento"}</button>
          </div>
        ))}
      </div>
    </div>
  );
}
